import { resaleRefund, type ResaleRule } from "@reagent/sim";

/**
 * `02-cards-and-economy.md` §3's depreciation ladder (spec 0021). Meta owns
 * the numbers; the engine only applies whatever rule `composeStage` hands it,
 * through the same `resaleRefund` this module calls, so what a dismantle
 * event reports and what the run's ledger charges are one computation.
 *
 * - 100 % in the setup it was bought in, 60 % after one completed stage, 25 %
 *   after two or more.
 * - A contaminated asset is worth nothing and costs 25 % of its price to
 *   dispose of — proportional, so a contaminated reactor hurts more than a
 *   contaminated pipe (Open Question 2).
 * - Every percentage is floored (Open Question 3): depreciation never pays
 *   more than its rung states, which is also what keeps a buy/sell loop from
 *   ever gaining Credits.
 */
export const RESALE_RULE: ResaleRule = { ladderPct: [100, 60, 25], disposalFeePct: 25 };

/**
 * What a unit bought for `costCredits` sells back for after `ageStages`
 * completed stages. Negative is a fee the player pays.
 */
export function resaleCredits(costCredits: number, ageStages: number, isContaminated: boolean): number {
  return resaleRefund(costCredits, ageStages, isContaminated, RESALE_RULE);
}
